(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[167],{

/***/ 5673:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[university]/[major]/[course]",
      function () {
        return __webpack_require__(4829);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 8530:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ useMeta; }
/* harmony export */ });
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8928);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);

function useMeta() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
    return {
        query: router.query,
        url: router.asPath
    };
}


/***/ }),

/***/ 4829:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Course; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2086);
/* harmony import */ var _components_index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1080);
/* harmony import */ var _hooks_useMeta__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8530);



function Course() {
    var query = (0,_hooks_useMeta__WEBPACK_IMPORTED_MODULE_2__/* .useMeta */ .j)().query;
    var name = query.university + "/" + query.major + "/" + query.course;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_index__WEBPACK_IMPORTED_MODULE_1__/* .Meta */ .h_, {
        title: "".concat(query.course, " page from ").concat(query.university, " "),
        description: "The page the shows the content of ".concat(query.course, " "),
        image: "https://axed.vercel.app/favicon-512.png",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_index__WEBPACK_IMPORTED_MODULE_1__/* .BreadcrumbList */ .Jb, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_index__WEBPACK_IMPORTED_MODULE_1__/* .BreadcrumbItems */ .xy, {
                        link: "",
                        name: "Home"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_index__WEBPACK_IMPORTED_MODULE_1__/* .BreadcrumbItems */ .xy, {
                        link: String(query.university),
                        name: String(query.university)
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_index__WEBPACK_IMPORTED_MODULE_1__/* .BreadcrumbItems */ .xy, {
                        link: String(query.university) + "/" + String(query.major),
                        name: String(query.major)
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_index__WEBPACK_IMPORTED_MODULE_1__/* .BreadcrumbItems */ .xy, {
                        current: true,
                        link: String(query.course),
                        name: String(query.course)
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_index__WEBPACK_IMPORTED_MODULE_1__/* .MainContent */ .M9, {
                query: name,
                link: "Homeworks",
                search: "Category"
            })
        ]
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,888,179], function() { return __webpack_exec__(5673); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);